import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AnimatePresence, motion } from 'framer-motion';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { isAdminLoggedIn } from '../modules/saas/utils/session';
import { consumeDeactivatedAccountMessage } from '../utils/deactivatedAccount';
import CryptoJS from "crypto-js";
import {
  Eye,
  EyeOff,
  Mail,
  Lock,
  ShieldCheck,
  Users,
  ArrowRight,
  ArrowUpRight,
  Sparkles,
  ShieldHalf,
  KeyRound,
} from 'lucide-react';
import brandIcon from '../Img/100BILLION_ICON.png';
import brandName from '../Img/100BILLION_TECH_name.png';

const STAFF_PORTAL_URL = "https://teams.beentara.com/";

const Login = () => {
  const [phone, setPhone] = useState(''); // State for phone number
  const [password, setPassword] = useState(''); // State for password
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [otpworld1, setOtpworld1] = useState(false);
  const [otpworld2, setOtpworld2] = useState(false);
  const [confirmObj, setConfirmObj] = useState("");
  const navigate = useNavigate();
  const urlmain = API_BASE_URL
  const [load, setLoad] = useState(true);
  const res = CryptoJS.AES.encrypt(JSON.stringify({ email: "test@example.com" }), "your-secret").toString();

  const user = getDecryptedUserFromCookie();
  const [showPassword, setShowPassword] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [userId, setUserId] = useState()
  const [mode, setMode] = useState("admin"); // "admin" | "staff"

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const message = consumeDeactivatedAccountMessage();
    if (message) {
      toast.error(message);
    }
    if (isAdminLoggedIn()) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);



  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };


  const handleCheckVerify = async (user_id) => {
    setUserId(user_id)
    try {
      const response = await fetch(`${urlmain}/two-step/login/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id })
      })

      const res = await response.json();
      if (response.ok) {
        setOtpModal(true);
        toast.success(res.message || "OTP sent successfully!");
        setLoad(true);
      } else {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("2xgxgshdugyywerw12eccom");
        toast.error(res.message || "Failed to send OTP. Please try again.");
        setLoad(true);
      }
    } catch (error) {
      console.error(error);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("2xgxgshdugyywerw12eccom");
      toast.error("Failed to send OTP. Please try again.");
      setLoad(true);
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(false)
    try {
      const response = await fetch(`${urlmain}/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: phone,
          password: password
        })
      })
      const res = await response.json();

      if (response.ok) {
        if (res.verify) {
          localStorage.setItem("2xgxgshdugyywerw12eccom", JSON.stringify(res.user))
          localStorage.setItem('accessToken', res.token);
          handleCheckVerify(res.data.main_id)

        } else {
          localStorage.setItem("2xgxgshdugyywerw12eccom", JSON.stringify(res.user))
          localStorage.setItem('accessToken', res.token);
          // handleCheckVerify(res.data.main_id)
          navigate("/dashboard");
          setLoad(true)
        }
        //


      } else {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("2xgxgshdugyywerw12eccom");
        toast.error(res.message || "Login failed. Please try again.");
        setLoad(true)
      }


    } catch (error) {
      const message =
        error?.message === "Failed to fetch"
          ? "Cannot reach the API server. If this persists, ask your host to restart api.beentara.com."
          : error?.message || "Login failed. Please try again.";
      toast.error(message);
      setLoad(true)
    }
  };

  const handleVerifyOtp = async (user_id) => {
    try {
      const response = await fetch(`${urlmain}/two-step/login/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ otp, user_id: userId }),
      });

      const res = await response.json();
      if (response.ok) {
        navigate("/dashboard");
        setOtpModal(false);
        toast.success('Login successful!');
        setOtp("");
      } else {
        toast.error(res.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  }

  const goToStaffPortal = () => {
    window.location.href = STAFF_PORTAL_URL;
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="relative min-h-screen w-full overflow-hidden bg-[#0a0f2e] font-sans text-white">
        {/* Animated aurora background */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <motion.div
            className="absolute -left-40 -top-40 h-[34rem] w-[34rem] rounded-full bg-cyan-500/35 blur-[120px]"
            animate={{ x: [0, 60, 0], y: [0, 40, 0] }}
            transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute -right-40 top-10 h-[30rem] w-[30rem] rounded-full bg-fuchsia-500/30 blur-[120px]"
            animate={{ x: [0, -50, 0], y: [0, 60, 0] }}
            transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute bottom-[-12rem] left-1/3 h-[32rem] w-[32rem] rounded-full bg-lime-400/20 blur-[140px]"
            animate={{ x: [0, 40, 0], y: [0, -40, 0] }}
            transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
          />
          {/* subtle grid */}
          <div
            className="absolute inset-0 opacity-[0.06]"
            style={{
              backgroundImage:
                "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
              backgroundSize: "44px 44px",
            }}
          />
        </div>

        <div className="relative z-10 mx-auto flex min-h-screen max-w-6xl items-center justify-center px-4 py-10">
          <div className="grid w-full overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] shadow-2xl backdrop-blur-xl lg:grid-cols-2">

            {/* ===== Left brand panel ===== */}
            <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-cyan-600/30 via-indigo-800/40 to-fuchsia-600/30 p-10 lg:flex">
              <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full border border-white/10" />
              <div className="pointer-events-none absolute -bottom-24 -left-10 h-72 w-72 rounded-full border border-white/10" />

              <div className="relative flex items-center gap-3">
                <img src={brandIcon} alt="100 Billion" className="h-11 w-11 object-contain drop-shadow-lg" />
                <img src={brandName} alt="100 Billion Tech" className="h-7 object-contain brightness-0 invert" />
              </div>

              <div className="relative">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-medium text-white/80"
                >
                  <Sparkles size={14} className="text-lime-300" />
                  Built for growth
                </motion.div>
                <motion.h1
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  className="text-4xl font-bold leading-tight tracking-tight"
                >
                  Run your whole<br />operation from<br />
                  <span className="bg-gradient-to-r from-cyan-300 via-lime-300 to-fuchsia-300 bg-clip-text text-transparent">
                    one command center.
                  </span>
                </motion.h1>
                <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
                 Trusted by 100+ brands and 1000+ sellers.
                </p>
              </div>

              <div className="relative grid grid-cols-3 gap-4">
                {[
                  { k: "99.9%", v: "Uptime" },
                  { k: "256-bit", v: "Encryption" },
                  { k: "2-Step", v: "Verified" },
                ].map((s) => (
                  <div key={s.v} className="rounded-2xl border border-white/10 bg-white/5 px-3 py-3 text-center">
                    <div className="text-lg font-bold text-white">{s.k}</div>
                    <div className="text-[11px] uppercase tracking-wider text-white/55">{s.v}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* ===== Right auth panel ===== */}
            <div className="flex flex-col justify-center p-7 sm:p-10">
              {/* Mobile brand */}
              <div className="mb-6 flex items-center gap-3 lg:hidden">
                <img src={brandIcon} alt="100 Billion" className="h-10 w-10 object-contain" />
                <img src={brandName} alt="100 Billion Tech" className="h-6 object-contain brightness-0 invert" />
              </div>

              <h2 className="text-2xl font-bold tracking-tight">Welcome back</h2>
              <p className="mt-1 text-sm text-white/60">Choose how you want to sign in.</p>

              {/* Segmented toggle */}
              <div className="relative mt-6 grid grid-cols-2 rounded-2xl border border-white/10 bg-white/5 p-1">
                <motion.div
                  className="absolute inset-y-1 w-[calc(50%-0.25rem)] rounded-xl bg-gradient-to-r from-cyan-500 to-fuchsia-500 shadow-lg"
                  animate={{ left: mode === "admin" ? "0.25rem" : "calc(50%)" }}
                  transition={{ type: "spring", stiffness: 320, damping: 30 }}
                />
                <button
                  type="button"
                  onClick={() => setMode("admin")}
                  className={`relative z-10 flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-semibold transition-colors ${mode === "admin" ? "text-white" : "text-white/60 hover:text-white/90"}`}
                >
                  <ShieldCheck size={16} /> Admin Login
                </button>
                <button
                  type="button"
                  onClick={() => setMode("staff")}
                  className={`relative z-10 flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-semibold transition-colors ${mode === "staff" ? "text-white" : "text-white/60 hover:text-white/90"}`}
                >
                  <Users size={16} /> Staff Login
                </button>
              </div>

              <div className="mt-6">
                <AnimatePresence mode="wait">
                  {mode === "admin" ? (
                    <motion.form
                      key="admin"
                      initial={{ opacity: 0, x: -16 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -16 }}
                      transition={{ duration: 0.25 }}
                      onSubmit={handleSubmit}
                      className="space-y-4"
                    >
                      <div>
                        <label className="mb-1.5 block text-xs font-medium text-white/70">Email address</label>
                        <div className="group relative">
                          <Mail size={18} className="pointer-events-none absolute left-3.5 top-1/2 z-10 -translate-y-1/2 text-cyan-400/70 transition-colors group-focus-within:text-cyan-300" />
                          <input
                            type="email"
                            name="phone"
                            placeholder="you@company.com"
                            value={phone}
                            onChange={handlePhoneChange}
                            autoComplete="email"
                            className="login-auth-input w-full rounded-xl border border-white/10 bg-white/5 py-3 pl-11 pr-4 text-sm text-white placeholder-white/30 outline-none transition focus:border-cyan-400/60 focus:bg-white/5 focus:ring-2 focus:ring-cyan-500/30"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="mb-1.5 block text-xs font-medium text-white/70">Password</label>
                        <div className="group relative">
                          <Lock size={18} className="pointer-events-none absolute left-3.5 top-1/2 z-10 -translate-y-1/2 text-cyan-400/70 transition-colors group-focus-within:text-cyan-300" />
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={handlePasswordChange}
                            autoComplete="current-password"
                            className="login-auth-input w-full rounded-xl border border-white/10 bg-white/5 py-3 pl-11 pr-11 text-sm text-white placeholder-white/30 outline-none transition focus:border-cyan-400/60 focus:bg-white/5 focus:ring-2 focus:ring-cyan-500/30"
                          />
                          <button
                            type="button"
                            onClick={togglePassword}
                            className="absolute right-3 top-1/2 z-10 -translate-y-1/2 text-cyan-400/70 transition-colors hover:text-cyan-300 group-focus-within:text-cyan-300"
                          >
                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                          </button>
                        </div>
                      </div>

                      <div className="flex items-center justify-between pt-1">
                        <p className="max-w-[14rem] text-[11px] leading-snug text-white/45">
                          By continuing, you agree to our{" "}
                          <Link to="/terms-conditions" className="text-cyan-300 hover:underline">Terms</Link> &{" "}
                          <Link to="/privacy" className="text-cyan-300 hover:underline">Privacy Policy</Link>.
                        </p>
                        <Link to="/reset" className="whitespace-nowrap text-xs font-semibold text-lime-300 hover:underline">
                          Forgot password?
                        </Link>
                      </div>

                      <button
                        type="submit"
                        disabled={!load}
                        className="group relative mt-1 flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-gradient-to-r from-cyan-500 via-violet-500 to-fuchsia-500 py-3 text-sm font-semibold text-white shadow-lg shadow-fuchsia-900/40 transition hover:shadow-fuchsia-700/50 disabled:cursor-not-allowed disabled:opacity-70"
                      >
                        {load ? (
                          <>
                            Continue
                            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                          </>
                        ) : (
                          <>
                            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                            Signing in...
                          </>
                        )}
                      </button>

                      <div className="flex items-center justify-center gap-2 pt-1 text-[11px] text-white/40">
                        <ShieldHalf size={13} className="text-lime-400" />
                        Protected with two-step verification
                      </div>

                      <div className="border-t border-white/10 pt-4 text-center">
                        <p className="mb-2 text-sm text-white/55">Don&apos;t have an account?</p>
                        <Link
                          to="/signup"
                          className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-cyan-400/40 bg-cyan-500/10 py-2.5 text-sm font-semibold text-cyan-300 transition hover:bg-cyan-500/20"
                        >
                          Register Now
                        </Link>
                      </div>
                    </motion.form>
                  ) : (
                    <motion.div
                      key="staff"
                      initial={{ opacity: 0, x: 16 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 16 }}
                      transition={{ duration: 0.25 }}
                      className="space-y-5"
                    >
                      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-lime-500/10 to-cyan-500/10 p-5">
                        <div className="flex items-start gap-4">
                          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-lime-400 to-cyan-500 shadow-lg">
                            <Users size={22} className="text-white" />
                          </div>
                          <div>
                            <h3 className="text-base font-semibold text-white">Staff Workspace</h3>
                            <p className="mt-1 text-sm leading-relaxed text-white/65">
                              Team members sign in through the dedicated staff portal to access tasks,
                              attendance, and daily operations.
                            </p>
                          </div>
                        </div>
                      </div>

                      <ul className="space-y-2.5">
                        {[
                          "Manage tasks & schedules",
                          "Track attendance in real time",
                          "Collaborate with your team",
                        ].map((item) => (
                          <li key={item} className="flex items-center gap-3 text-sm text-white/75">
                            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-lime-500/20 text-lime-300">
                              <KeyRound size={12} />
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>

                      <button
                        type="button"
                        onClick={goToStaffPortal}
                        className="group flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-lime-500 to-cyan-500 py-3 text-sm font-semibold text-[#0a1138] shadow-lg shadow-cyan-900/40 transition hover:shadow-lime-700/40"
                      >
                        Go to Staff Portal
                        <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </button>

                      <p className="text-center text-[11px] text-white/40">
                        You'll be redirected to{" "}
                        <span className="text-cyan-300">teams.beentara.com</span>
                      </p>

                      <div className="border-t border-white/10 pt-4 text-center">
                        <p className="mb-2 text-sm text-white/55">Don&apos;t have an account?</p>
                        <Link
                          to="/signup"
                          className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-cyan-400/40 bg-cyan-500/10 py-2.5 text-sm font-semibold text-cyan-300 transition hover:bg-cyan-500/20"
                        >
                          Register Now
                        </Link>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>

        {/* ===== OTP Modal ===== */}
        <AnimatePresence>
          {otpModal && (
            <motion.div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.95, y: 10 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95, y: 10 }}
                transition={{ type: "spring", stiffness: 300, damping: 26 }}
                className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#0d1230] p-6 text-white shadow-2xl"
              >
                <div className="mb-4 flex flex-col items-center text-center">
                  <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-cyan-500 to-fuchsia-500 shadow-lg">
                    <ShieldCheck size={22} className="text-white" />
                  </div>
                  <h3 className="text-lg font-semibold">OTP Verification</h3>
                  <p className="mt-1 text-xs text-white/55">Enter the code we sent to verify it's you.</p>
                </div>

                <label className="mb-1.5 block text-xs font-medium text-white/70">Enter OTP</label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleVerifyOtp();
                  }}
                  className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center text-lg font-semibold tracking-[0.4em] text-white outline-none transition focus:border-cyan-400/60 focus:bg-white/10 focus:ring-2 focus:ring-cyan-500/30"
                  placeholder="••••••"
                />

                <div className="mt-5 flex gap-3">
                  <button
                    onClick={() => setOtpModal(false)}
                    className="flex-1 rounded-xl border border-white/15 bg-white/5 py-2.5 text-sm font-semibold text-white/80 transition hover:bg-white/10"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleVerifyOtp}
                    className="flex-1 rounded-xl bg-gradient-to-r from-cyan-500 to-fuchsia-500 py-2.5 text-sm font-semibold text-white shadow-lg transition hover:shadow-fuchsia-700/50"
                  >
                    Verify
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default Login;
